import { TruckIcon } from "asset/icons";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import currencyPairCheck from "utilities/currencyPairCheck";
import { formatMoney } from "utilities/formatMoney";
import CurrencyToggle from "component/currencyToggle";
import { useQuery } from "react-query";
import { handleFetchStats } from "api/fetchers";
import Metrics from "component/flex/Metrics";
import ProcurementTable from "component/flex/ProcurementTable";
import { trackFeatureUsage } from "utilities/trackFeatureUsage";
import CustomHeader from "component/CustomHeader";

const Procurement = ({ loadedPoDataRef }) => {
    const [activeTab, setActiveTab] = useState("Purchase orders");
    const { business, currency } = useSelector((state) => state);
    const isBusinessApproved = business?.status === "APPROVED";
    const navigate = useNavigate();

    const { data, isLoading: loadingStats } = useQuery({
        queryKey: ["fetchStats", business?._id],
        queryFn: () => handleFetchStats({ businessId: business?._id }),
    });

    const orderDetails =
        data?.allOrders?.currencyBreakdown?.find((item) => item.currency === currency) ?? {};

    return (
        <div className="w-full">
            <CustomHeader title="Procurement">
                <button
                    className={`!py-2 !px-4 rounded-lg !text-[#FBFAFF] bg-[#5E01D6] max-375:text-sm
        ${!isBusinessApproved ? "opacity-50 cursor-not-allowed" : ""}`}
                    onClick={() => {
                        if (isBusinessApproved) {
                            trackFeatureUsage("create_po", business?._id || "guest"); // Track feature usage
                            navigate("/flex/create-po");
                        }
                    }}
                    disabled={!isBusinessApproved} // Prevent click action
                >
                    New Purchase Order
                </button>
            </CustomHeader>
            <>
                <p className="font-[550] !text-[17px] text-main flex items-center !mt-3 !mb-3 !px-0">
                    Overview{" "}
                    <CurrencyToggle
                        className="!bg-[#DBDFE5] !ml-2.5"
                        dropDownClassName="shadow-dropdown2 !left-0 !top-[109%]"
                        hideLabel
                        isDisabled={!isBusinessApproved}
                    />
                </p>
                <div className="grid grid-cols-[280px,304px] 900:grid-cols-[repeat(2,280px)] !gap-6 !ml-0  overflow-x-auto [scrollbar-width:none]">
                    <Metrics
                        title="All orders"
                        value={loadingStats ? "--" : formatMoney(orderDetails?.totalOrders ?? 0)}
                        meta={
                            <p className="text-main-grey !text-sm">
                                {currencyPairCheck(currency)}{" "}
                                <span className="text-main !mr-0.5 text-base">
                                    {loadingStats
                                        ? "--"
                                        : formatMoney(orderDetails?.totalPaidAmount ?? 0)}
                                </span>{" "}
                                spent so far
                            </p>
                        }
                    />
                    <Metrics
                        className="max-900:mr-6"
                        title="Open orders"
                        value={loadingStats ? "--" : orderDetails?.totalOpenOrder ?? 0}
                        meta={
                            <p className="flex items-center text-main-grey !text-sm">
                                <TruckIcon className="!size-[18px]" />{" "}
                                <span className="text-main !ml-2 !mr-1 text-base">
                                    {loadingStats ? "--" : orderDetails?.inTransit ?? 0}
                                </span>{" "}
                                In transit
                            </p>
                        }
                    />
                </div>
            </>

            <>
                <div className="flex !gap-8 !mt-[34px] !px-0">
                    {["Purchase orders"].map((tab) => (
                        <p
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`border-b-2 cursor-pointer !pb-2 transition-all ${
                                activeTab === tab
                                    ? "font-[450] text-main-dark border-b-secondary"
                                    : "text-main-grey border-b-transparent"
                            }`}
                        >
                            {tab}
                        </p>
                    ))}
                </div>
                <ProcurementTable
                    quotesTab={activeTab === "Quotes"}
                    business={business}
                    currency={currency}
                    loadedPoDataRef={loadedPoDataRef}
                />
            </>
        </div>
    );
};

export default Procurement;
